import { AjaxLoader } from './ajax-loader';
import './tooltip-manager-mobile';
import './tooltip-manager-web';
import '../../Styles/main.scss';
new AjaxLoader();
